import { Entity, Field } from "typegraph";

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: string;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/assignments/entities/Product.ts